import { mockData } from '../mock';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

export const TestimonialList = () => (
  <section id="testimonials" className="py-20 bg-gradient-to-b from-slate-50 to-white">
    <div className="container mx-auto px-4">
      <div className="text-center mb-12">
        <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">What Our Clients Say</h3>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">Real stories from real people we've helped navigate their Medicare options</p>
      </div>
      <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
        {mockData.testimonials.map((testimonial) => (
          <Card key={testimonial.id} className="hover:shadow-lg transition-all border-l-4 border-l-blue-600">
            <CardHeader>
              <div className="flex items-center space-x-1 mb-2">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <svg key={`star-${testimonial.id}-${i}`} className="h-5 w-5 fill-yellow-400 text-yellow-400" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
              <CardTitle className="text-lg">{testimonial.name}</CardTitle>
              <CardDescription className="text-sm">{testimonial.location}</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600 italic leading-relaxed">"{testimonial.text}"</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </section>
);
